import { subscriptionsMindboxService } from '@/fo/api/mindbox';

export const hasSubscriptions = async (email: string) => {
  const response =
    await subscriptionsMindboxService.getCustomerSubscriptionsByEmail({
      email
    });

  if ('error' in response) {
    return false;
  }

  return (
    response.customer?.subscriptions?.some(
      (subscription) =>
        subscription.pointOfContact === 'Email' && subscription.isSubscribed
    ) ?? false
  );
};
